import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

function IadeKosullari() {
  return (
    <Container maxWidth="md" sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          İade Koşulları
        </Typography>

        <Typography paragraph>
          Kayla Butik olarak müşteri memnuniyeti bizim için önemlidir. Ürünlerimizle ilgili iade süreçlerimiz aşağıdaki gibidir:
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İade Süresi
        </Typography>
        <Typography paragraph>
          Satın aldığınız ürünleri, teslim tarihinden itibaren 14 gün içerisinde iade edebilirsiniz.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İade Koşulları
        </Typography>
        <Typography component="div">
          <Box component="ul" sx={{ pl: 2 }}>
            <li>Ürün kullanılmamış ve yıkanmamış olmalıdır</li>
            <li>Ürün etiketleri sökülmemiş olmalıdır</li>
            <li>Orijinal ambalajında olmalıdır</li>
            <li>Ürün defolu, zarar görmüş olmamalıdır</li>
          </Box>
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İade Süreci
        </Typography>
        <Typography paragraph>
          İade işleminizi başlatmak için müşteri hizmetlerimiz ile iletişime geçebilirsiniz.
          İade onayı aldıktan sonra, ürünü anlaşmalı kargo firmamız ile ücretsiz olarak gönderebilirsiniz.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İade Ödemesi
        </Typography>
        <Typography paragraph>
          İade edilen ürün tarafımıza ulaştıktan ve kontrolleri yapıldıktan sonra, 
          ödeme iadesi en geç 14 iş günü içerisinde yapılacaktır.
        </Typography>
      </Paper>
    </Container>
  );
}

export default IadeKosullari; 